/* eslint-disable no-case-declarations */
import {TASKMANAGE} from 'Constants/ActionTypes';
// import {getWeekDays} from 'Utils';
import moment from 'moment';

// range为5，生成0~5相邻不重复的随机数
function random(range = 5) {
  const current = Math.floor(Math.random() * range);

  if (random.prev !== current) {
    random.prev = current;

    return current;
  }

  return random(range);
}
function restructureLabels(labels) {
  if (Array.isArray(labels)) {
    return labels.map(label => Object.assign(label, {color: random()}));
  }
  return [];
}
const {
  GET_TASK_DETAIL_TASK_NAME_OPTIONS,
  GET_TASK_DETAIL_WORD_STRATEGY_ID_OPTIONS,
  SET_TASK_DETAIL_SEARCH_DATA,
  SET_TASK_DETAIL_SELECTD_ROW_KEYS,
  GET_TASK_DETAIL_LIST,
  SET_TASK_DETAIL_PAGE_STATUS,
  GET_TASK_DETAIL_DETAIL_DRAWER_DATA,
  SET_TASK_DETAIL_DETAIL_DRAWER_DATA,
  GET_CUSTOMIZE_TASK_DETAIL_LIST,
  GET_BATCH_OPTIONS,
  SET_TASK_DETAIL_RECALL_DATA,
} = TASKMANAGE;

const initialState = {
  taskNameOptions: [], // 任务名称下拉框
  wordStrategyIdOptions: [], // 话术名称下拉框
  batchList: [],
  reCallModalData: {
    taskInfoId: '',
    batchId: '',
  },
  searchData: {
    commitTimeStart: moment(`${moment().format('YYYY-MM-DD')} 00:00:00`).format(
      'x',
    ),
    commitTimeEnd: moment(`${moment().format('YYYY-MM-DD')} 23:59:59`).format(
      'x',
    ),
    orderKey: 'commit_time',
  }, // 搜索条件
  selectedRowKeys: [], // 列表筛选项
  tableListData: {
    data: [],
    total: 0,
  }, // table数据
  pageStatus: {
    pageNum: 1,
    pageSize: 20,
  }, // pageNum与pageSize
  detailDrawerData: {}, // 通话详情抽屉数据
  customizeDetailList: {
    data: [],
    total: 0,
  },
};

const detail = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_TASK_DETAIL_TASK_NAME_OPTIONS}_SUCCESS`:
      return {
        ...state,
        taskNameOptions: action.payload.data,
      };
    case `${GET_TASK_DETAIL_WORD_STRATEGY_ID_OPTIONS}_SUCCESS`:
      return {
        ...state,
        wordStrategyIdOptions: action.payload.data,
      };
    case `${GET_BATCH_OPTIONS}_SUCCESS`:
      return {
        ...state,
        batchList: action.payload.data,
      };
    case `${SET_TASK_DETAIL_SEARCH_DATA}`:
      return {
        ...state,
        searchData: action.data,
      };
    case `${SET_TASK_DETAIL_RECALL_DATA}`:
      return {
        ...state,
        reCallModalData: action.data,
      };
    case `${SET_TASK_DETAIL_SELECTD_ROW_KEYS}`:
      return {
        ...state,
        selectedRowKeys: action.data,
      };
    case `${GET_TASK_DETAIL_LIST}_SUCCESS`:
      return {
        ...state,
        tableListData: {
          data: (action.payload.data && action.payload.data.list) || [],
          total: (action.payload.data && action.payload.data.total) || 0,
        },
      };
    case `${GET_TASK_DETAIL_LIST}_FAIL`:
      return {
        ...state,
        tableListData: {
          data: [],
          total: 0,
        },
      };
    case `${SET_TASK_DETAIL_PAGE_STATUS}`:
      return {
        ...state,
        pageStatus: {...state.pageStatus, ...action.data},
      };
    case `${GET_TASK_DETAIL_DETAIL_DRAWER_DATA}_SUCCESS`:
      let {data, data: {labels = []} = {}} = action.payload || {};
      labels = restructureLabels(labels);
      data = {
        ...data,
        labels,
      };
      return {
        ...state,
        detailDrawerData: data,
      };
    case `${SET_TASK_DETAIL_DETAIL_DRAWER_DATA}`:
      return {
        ...state,
        detailDrawerData: action.data,
      };
    case `${GET_CUSTOMIZE_TASK_DETAIL_LIST}_SUCCESS`:
      return {
        ...state,
        tableListData: {
          data: (action.payload.data && action.payload.data.list) || [],
          total: (action.payload.data && action.payload.data.total) || 0,
        },
      };
    default:
      return state;
  }
};

export default detail;
